import { render, staticRenderFns } from "./progressbar.vue?vue&type=template&id=628fdc46&"
import script from "./progressbar.vue?vue&type=script&lang=js&"
export * from "./progressbar.vue?vue&type=script&lang=js&"
import style0 from "./progressbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports